"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisualMediaSource = exports.isVideoSource = exports.isScreenPresenter = exports.isPresenterSource = exports.isMediaSource = exports.isImageSource = exports.isCameraPresenter = exports.isAudioVideoSource = exports.isAudioSource = void 0;
var _constants = require("@studio/constants");
var isAudioSource = exports.isAudioSource = function isAudioSource(source) {
  return source && source.type === _constants.AUDIO_FILE;
};
var isAudioVideoSource = exports.isAudioVideoSource = function isAudioVideoSource(source) {
  return [_constants.VIDEO_FILE, _constants.AUDIO_FILE].includes(source.type);
};
var isCameraPresenter = exports.isCameraPresenter = function isCameraPresenter(source) {
  return source && source.type === _constants.CAMERA_PRESENTER;
};
var isImageSource = exports.isImageSource = function isImageSource(source) {
  return source && source.type === _constants.IMAGE_FILE;
};
var isMediaSource = exports.isMediaSource = function isMediaSource(source) {
  return [_constants.VIDEO_FILE, _constants.AUDIO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE, _constants.MEDIA].includes(source.type);
};
var isPresenterSource = exports.isPresenterSource = function isPresenterSource(source) {
  return [_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes(source.type);
};
var isScreenPresenter = exports.isScreenPresenter = function isScreenPresenter(source) {
  return source && source.type === _constants.SCREEN_PRESENTER;
};
var isVideoSource = exports.isVideoSource = function isVideoSource(source) {
  return source && source.type === _constants.VIDEO_FILE;
};
var isVisualMediaSource = exports.isVisualMediaSource = function isVisualMediaSource(source) {
  return [_constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.SCREEN_PRESENTER, _constants.PDF_FILE].includes(source.type);
};